import { render, staticRenderFns } from "./SearchTransferApplicationTable.vue?vue&type=template&id=f0815c6c"
import script from "./SearchTransferApplicationTable.vue?vue&type=script&lang=js"
export * from "./SearchTransferApplicationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports